import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Link from 'gatsby-link'
import classnames from 'classnames'
import { ReactComponent as Download } from '@assets/svgs/icons/download.svg'
import { ReactComponent as DownloadWhite } from '@assets/svgs/icons/download-white.svg'
import { ReactComponent as DownloadRed } from '@assets/svgs/icons/download-red.svg'
import { supportsWebp } from '../../helpers/webp'
import './Brochure.module.scss'
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

const Brochure = ({ brochure, simple = false }) => {
  const [format, setFormat] = useState('jpg')
  supportsWebp((isSupported) => {
    if (isSupported) {
      setFormat('webp')
    }
  })
  var imageSrc = R.path(['coverImage', 'resize', 'src'], brochure)
  if (!imageSrc.includes('progressive')) {
    imageSrc = imageSrc + `&fm=${format}`
  }
  const title = R.prop('title', brochure)
  const description = R.prop('description', brochure)
  const fileUrl = R.path(['brochure', 'file', 'url'], brochure)
  const linkUrl = R.prop('linkUrl', brochure)
  const inverted = linkUrl != null && simple

  return (
    <div styleName={classnames('brochureWrapper', { simple }, { inverted })}>
      <div styleName={classnames('coverImage', { simple }, { inverted })}>
        <img src={imageSrc} alt={title.replace('™', '')} />
      </div>
      <div styleName='infoWrapper'>
        {title && <h2 styleName={classnames('heading', { simple })}>{title}</h2>}
        {!simple && description && <p styleName='description'>{description}</p>}
        { fileUrl && <Link to={fileUrl} target='_blank'>
          {simple ? (
            <DownloadWhite aria-hidden='true' styleName={classnames('download', { simple })} />
          ) : (
            <Download aria-hidden='true' styleName='download' />
          )}
          <span class='sr-only'>Download</span></Link> }

        { linkUrl && <a href={linkUrl} target='_blank' rel='noopener noreferrer'>
          {simple ? (
            <DownloadRed aria-hidden='true' styleName={classnames('download', { simple })} />
          ) : (
            <Download aria-hidden='true' styleName='download' />
          )}
          <span class='sr-only'>Download</span></a> }
      </div>
      {simple && fileUrl && <Link to={fileUrl} target='_blank' styleName='simple-link'><span class='sr-only'>Link to brochure file</span></Link>}
      {simple && linkUrl && <a href={linkUrl} target='_blank' rel='noopener noreferrer' styleName='simple-link'><span class='sr-only'>Link to brochure</span></a> }

    </div>
  )
}

Brochure.propTypes = {
  brochure: PropTypes.object.isRequired,
  simple: PropTypes.bool
}

export default Brochure



// WEBPACK FOOTER //
// ./src/components/Brochure/Brochure.js